import { VoiceServiceError, type VoiceProvider } from "../../types";

/** Every method fails predictably with `"not-implemented"` rather than
 * silently doing nothing — callers (`voiceService.ts`) catch this and
 * surface a clear "isn't installed yet" toast instead of a dead button. */
export const StubVoiceProvider: VoiceProvider = {
  transcribe() {
    return Promise.reject(
      new VoiceServiceError("not-implemented", "Local speech-to-text isn't installed yet."),
    );
  },

  // eslint-disable-next-line require-yield, @typescript-eslint/require-await -- must stay an async generator to match the AsyncGenerator contract even though it always throws before yielding or awaiting.
  async *synthesize() {
    throw new VoiceServiceError("not-implemented", "Local text-to-speech isn't installed yet.");
  },
};
